module.exports = {"title":"SciChess","headline":"Where Chess meets Science!","startLearning":"Start Learning","watchVideo":"Watch the video"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/home/en/jumbotron.yml
// module id = 953
// module chunks = 173894859265406